import { VENDOR_WORKING_STATUSES, VENDOR_WORKING_STATUSES_VALUES } from 'domain/finance/vendors/constants';
import { Badge, type BadgeProps } from 'framework/ui/mui-builder';

const VENDOR_WORKING_STATUSES_COLOR: Record<VENDOR_WORKING_STATUSES, BadgeProps['color']> = {
  [VENDOR_WORKING_STATUSES.ACTIVE]: 'success',
  [VENDOR_WORKING_STATUSES.INACTIVE]: 'default',
};

const VendorWorkingStatusBadge = ({ status }: { status: VENDOR_WORKING_STATUSES }) => (
  <Badge id="workingStatus" color={VENDOR_WORKING_STATUSES_COLOR[status] || 'default'}>
    {VENDOR_WORKING_STATUSES_VALUES[status]}
  </Badge>
);

export default VendorWorkingStatusBadge;
